import React from 'react';
import { ArrowLeft, Cookie, Settings, BarChart3, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logoUrl } from '../mockData';

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#1B2380] hover:text-[#0E8C84] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <div className="flex items-center space-x-4 mb-8">
            <div className="w-14 h-14 bg-gradient-to-br from-[#E67E22] to-[#8FE3DA] rounded-xl flex items-center justify-center">
              <Cookie className="text-white" size={28} />
            </div>
            <h1 className="text-3xl sm:text-4xl font-bold text-[#1B2380]">
              Cookie Policy
            </h1>
          </div>

          <p className="text-lg text-gray-700 mb-8 leading-relaxed">
            Il sito di <strong>Assietica Soc Coop Società Benefit</strong> utilizza:
          </p>

          <div className="space-y-6">
            {/* Cookie Tecnici */}
            <div className="bg-[#1B2380]/5 rounded-xl p-6 border border-[#1B2380]/10 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#1B2380] rounded-xl flex items-center justify-center flex-shrink-0">
                  <Settings className="text-white" size={24} />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-[#1B2380] mb-2">Cookie Tecnici</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Necessari per il corretto funzionamento del sito e per la gestione delle sessioni 
                    di richiesta preventivo. Il sito utilizza inoltre la memoria locale del browser
                    (localStorage e sessionStorage) esclusivamente per finalità tecniche: memorizzare la
                    scelta espressa sui cookie e la chiusura degli avvisi di servizio. Questi elementi non
                    tracciano l'utente e non richiedono consenso.
                  </p>
                  <span className="inline-block mt-3 px-3 py-1 bg-[#1B2380]/10 text-[#1B2380] text-sm font-medium rounded-full">
                    Sempre attivi
                  </span>
                </div>
              </div>
            </div>

            {/* Cookie Analitici */}
            <div className="bg-[#0E8C84]/5 rounded-xl p-6 border border-[#0E8C84]/10 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#0E8C84] rounded-xl flex items-center justify-center flex-shrink-0">
                  <BarChart3 className="text-white" size={24} />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-[#0E8C84] mb-2">Cookie Analitici</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Il sito utilizza <strong>PostHog Analytics</strong>, uno strumento di analisi che
                    raccoglie dati di navigazione in forma pseudonimizzata (pagine visitate,
                    interazioni) per finalità statistiche e di miglioramento del servizio.
                    Titolare del trattamento: PostHog Inc. (server negli USA — trasferimento dati ex
                    Capo V GDPR). Durata dei cookie: fino a 12 mesi.
                  </p>
                  <p className="text-gray-700 leading-relaxed mt-2">
                    Questi cookie vengono installati <strong>solo previo consenso</strong> espresso
                    tramite il banner presente sul sito. In assenza di consenso, PostHog non viene
                    attivato.
                  </p>
                  <span className="inline-block mt-3 px-3 py-1 bg-[#0E8C84]/10 text-[#0E8C84] text-sm font-medium rounded-full">
                    Attivi solo con consenso
                  </span>
                </div>
              </div>
            </div>

            {/* Cookie di Terze Parti */}
            <div className="bg-[#0E8C84]/5 rounded-xl p-6 border border-[#0E8C84]/10 hover:shadow-md transition-shadow duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#0E8C84] rounded-xl flex items-center justify-center flex-shrink-0">
                  <Globe className="text-white" size={24} />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-[#0E8C84] mb-2">Cookie di Terze Parti</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Eventualmente presenti per l'integrazione di mappe o font esterni.
                  </p>
                  <span className="inline-block mt-3 px-3 py-1 bg-[#0E8C84]/10 text-[#0E8C84] text-sm font-medium rounded-full">
                    Opzionali
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Gestione Cookie */}
          <div className="mt-10 bg-[#8FE3DA]/10 rounded-xl p-6 border border-[#8FE3DA]/20">
            <div className="flex items-start space-x-4">
              <div className="w-10 h-10 bg-[#8FE3DA]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <Settings className="text-[#E67E22]" size={20} />
              </div>
              <div>
                <h3 className="font-bold text-gray-800 mb-2">Gestione delle preferenze</h3>
                <p className="text-gray-700 leading-relaxed">
                  L'utente può gestire le preferenze sui cookie direttamente dal proprio browser.
                </p>
              </div>
            </div>
          </div>

          {/* Back button */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-[#1B2380] to-[#0E8C84] text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              Torna alla Home
            </button>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-[#10154F] text-white py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Assietica Società Cooperativa. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default CookiePolicy;
